import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { CalculatorResultRow } from "web_myplann/Calculators/Types/CalculatorResultRow";
import { LabeledValueRow } from "web_myplann/Shared/Components/LabeledValueRow";

type Props = {
	rows: CalculatorResultRow[];
};

export const CalculatorResultRows: FC<Props> = ({ rows }) => {
	const theme = useTheme();

	return (
		<Stack mt={theme.spacingTokens.lg} gap={theme.spacingTokens.sm}>
			{rows.map((row) => (
				<LabeledValueRow
					key={row.label}
					label={
						<Typography variant="caption" color={theme.palette.grey[600]}>
							{row.label}
						</Typography>
					}
					value={
						<Typography variant="value" tabular textAlign="right">
							{row.value}
						</Typography>
					}
				/>
			))}
		</Stack>
	);
};
